import { render, staticRenderFns } from "./researchProjects.vue?vue&type=template&id=3c18fc5d&scoped=true&"
import script from "./researchProjects.vue?vue&type=script&lang=js&"
export * from "./researchProjects.vue?vue&type=script&lang=js&"
import style0 from "./researchProjects.vue?vue&type=style&index=0&id=3c18fc5d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c18fc5d",
  null
  
)

export default component.exports